<template>
  <el-dialog :close-on-click-modal="false"  
    title="订单审核"
    :visible.sync="visible"
    width="540px"
    class="auditOrder"
    :before-close="handleClose"
    
  >
    <el-form :model="orderData" ref="form" label-width="80px">
      <el-form-item label="订单编号：" style="width: 50%;">
        {{ orderData.appNo }}
      </el-form-item>
      <el-form-item label="商家账号：" style="width: 50%;">
        {{ orderData.pOperNo }}
      </el-form-item>
      <el-form-item label="审核结果：">
        <el-radio-group v-model="form.orderStatus">
          <el-radio label="03">通过</el-radio>
          <el-radio label="07">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核意见：">
        <el-input
          v-model="form.auditOpinion"
          class="input"
          size="small"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { auditSale } from '@/api/order/all'

export default {
  name: "AuditOrder",
  data() {
    return {
      form: {
        orderStatus: '03',
        auditOpinion: ''
      }
    };
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    orderData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    sure() {
      if(this.form.orderStatus == '07' && this.form.auditOpinion == ''){
        this.msgError('请填写审核意见')
        return
      }
      auditSale({
        appNo: this.orderData.appNo,
        orderStatus: this.form.orderStatus,
        auditOpinion: this.form.auditOpinion,
      }).then(res => {
        if (res.code !== 200) {
          this.$message.error("提交失败")
        } else {
          this.$message.success("提交成功")
          this.$emit("onOk");
        }
      })
    },
    handleClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style scoped>
.auditOrder {
  font-size: 12px;
}
.item {
  display: flex;
  flex-wrap: wrap;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}

.blue {
  color: #129ba7;
}
</style>
